import { createSelector } from "reselect";
import _ from "lodash";

export const selectTMPlans = ({ MultiDBViewer_reducer }) => {
    return MultiDBViewer_reducer.requestedTMPlans;
};

export const EndPoints = ({ MultiDBViewer_reducer }) => {
    return MultiDBViewer_reducer.endpoints;
};

export const getRequestedTmPlans = ({ MultiDBViewer_reducer }) => {
    return MultiDBViewer_reducer.plans;
};

export const selectReportFilterState = ({ MultiDBViewer_reducer }) => {
    return MultiDBViewer_reducer.filterState;
};
export const selectRowsPerPage = ({ MultiDBViewer_reducer }) => {
    return MultiDBViewer_reducer.rowsPerPage;
};
export const selectPage = ({ MultiDBViewer_reducer }) => {
    return MultiDBViewer_reducer.page;
};
export const selectSelectedRow = ({ MultiDBViewer_reducer }) => {
    return MultiDBViewer_reducer.selectedRow;
};

export const selectDeleteStatus = ({ MultiDBViewer_reducer }) => {
    return MultiDBViewer_reducer.deletedStatus;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["requested_tm_plans"];
        } else return false;
    }
);
export const canRead = createSelector([selectPermissions], (config = false) => {
    return config ? config.read : true;
});
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.update : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.create : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.delete : true;
    }
);

export const selectEndPoints = createSelector(
    [EndPoints],
    endPoints => {
        if (endPoints === false || typeof endPoints === "undefined" || endPoints === null) {
            return [];
        }
        let endPoint = Object.values(endPoints).map(endPoint => {
            
            return endPoint 
        })
        return endPoint;
    }
)

export const selectTableData = createSelector(
    [selectTMPlans],
    (tmplans = false) => {
        if (tmplans) {
            let data = [];

            Object.keys(tmplans).map((e, i) => {
                let sample = tmplans[e];
                let newTMflag = false;

                data.map(f => {
                    let test = f.plan;
                    if (
                        sample.lighting === test.lighting &&
                        sample.maxSiteLength === test.maxSiteLength &&
                        sample.maxTrafficCount === test.maxTrafficCount &&
                        sample.minUnobstructedWidth ===
                            test.minUnobstructedWidth &&
                        sample.minVisibility === test.minVisibility &&
                        sample.noAdvanceSigns === test.noAdvanceSigns &&
                        sample.roadPart === test.roadPart &&
                        sample.roadwayWidth === test.roadwayWidth &&
                        sample.signSize === test.signSize &&
                        sample.speed === test.speed &&
                        sample.time === test.time
                    ) {
                        f.count++;
                        f.timestamps.push(e);
                        newTMflag = false;
                    } else {
                        newTMflag = true;
                    }
                    return false;
                });

                if (data.length <= 0)
                    data.push({ count: 1, plan: sample, timestamps: [e] });
                if (newTMflag)
                    data.push({ count: 1, plan: sample, timestamps: [e] });
                return false;
            });

            return _.orderBy(data, "count").reverse();
        } else {
            return false;
        }
    }
);
